import { Star, Car, Instagram, Eye, Trophy, ArrowUpRight } from "lucide-react";
import { GMB_URL, BRAND } from "../mock";
import { openExternal } from "../lib/openExternal";

function GoogleG({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303a12 12 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819A11.99 11.99 0 0 1 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36a12 12 0 0 1-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
    </svg>
  );
}

const ITEMS = [
  {
    icon: GoogleG,
    value: "250+",
    label: "Google Reviews",
    sub: "5.0 ★ verified",
    href: GMB_URL,
  },
  {
    icon: Car,
    value: "1,500+",
    label: "Cars Coated",
    sub: "Since 2023",
  },
  {
    icon: Trophy,
    value: "#1",
    label: "On Google",
    sub: "Ceramic coating · Mississauga",
  },
  {
    icon: Instagram,
    value: "20K+",
    label: "Instagram Followers",
    sub: "@jesterwerks.gta",
    href: BRAND.socials.instagram,
  },
  {
    icon: Eye,
    value: "1M+",
    label: "Monthly Views",
    sub: "Across our content",
  },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-14 md:py-16 border-y border-white/5 bg-[#0c0119]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {ITEMS.map((s, i) => {
            const Icon = s.icon;
            const isLink = !!s.href;
            const Comp = isLink ? "a" : "div";
            const linkProps = isLink
              ? {
                  href: s.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  onClick: (e) => {
                    e.preventDefault();
                    openExternal(s.href);
                  },
                }
              : {};
            return (
              <Comp
                key={i}
                data-testid={`stat-card-${i}`}
                {...linkProps}
                className={[
                  "relative rounded-xl border border-white/10 bg-[#1a0938]/60 px-5 py-5 md:px-6 md:py-6",
                  "transition-all duration-300",
                  isLink
                    ? "hover:border-acid/60 hover:bg-[#1a0938] cursor-pointer group"
                    : "group",
                ].join(" ")}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="w-9 h-9 rounded-lg bg-jester-purple/15 border border-white/10 flex items-center justify-center group-hover:border-acid/40 transition-colors">
                    <Icon className="w-4.5 h-4.5 text-acid" style={{ width: 18, height: 18 }} />
                  </div>
                  {isLink && (
                    <ArrowUpRight className="w-3.5 h-3.5 text-white/30 group-hover:text-acid transition-colors" />
                  )}
                </div>

                <div className="font-stencil text-3xl md:text-4xl leading-none text-white group-hover:text-acid transition-colors">
                  {s.value}
                </div>
                <div className="mt-2 text-[13px] font-semibold text-white/90 leading-tight">
                  {s.label}
                </div>
                <div className="mt-0.5 text-[11px] text-white/45 leading-snug">
                  {s.sub}
                </div>
              </Comp>
            );
          })}
        </div>

        <div
          data-testid="stats-cta"
          className="mt-7 flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.3em] text-white/40 font-label"
        >
          <span className="text-acid">♦</span>
          <span>{BRAND.rating.value} stars · 100% transparent · 5-year coating warranty</span>
          <span className="text-acid">♦</span>
        </div>
      </div>
    </section>
  );
}
